export default __webpack_public_path__ + "static/media/logo.da22472f.svg";